import { MenuModulePayloadModel, MenuModuleModel } from '../types/menuTypes';

export const mockWardModules: MenuModuleModel[] = [
  {
    id: 1,
    name: 'Ma vie académique',
    nameTranslations: [
      { culture: 'en', value: 'My Academic Life' },
      { culture: 'fr', value: 'Ma vie académique' },
    ],
    order: 1,
    hidden: false,
  },
  {
    id: 2,
    name: 'Ma vie professionnelle',
    nameTranslations: [
      { culture: 'en', value: 'My Professional Life' },
      { culture: 'fr', value: 'Ma vie professionnelle' },
    ],
    order: 2,
    hidden: false,
  },
  {
    id: 3,
    name: 'Administratif',
    nameTranslations: [
      { culture: 'en', value: 'Administrative' },
      { culture: 'fr', value: 'Administratif' },
    ],
    order: 3,
    hidden: false,
  },
  {
    id: 4,
    name: 'Vie pratique',
    nameTranslations: [
      { culture: 'en', value: 'Practical Life' },
      { culture: 'fr', value: 'Vie pratique' },
    ],
    order: 4,
    hidden: false,
  },
];

export class MockWardModulesManagementService {
  static async getModules(): Promise<MenuModuleModel[]> {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(mockWardModules);
      }, 1000);
    });
  }

  static async createModule(newModule: MenuModulePayloadModel): Promise<MenuModuleModel> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const id = mockWardModules.length ? Math.max(...mockWardModules.map((m) => m.id)) + 1 : 1;
        const newModuleWithId: MenuModuleModel = {
          ...newModule,
          id: id,
        };
        mockWardModules.push(newModuleWithId);
        resolve(newModuleWithId);
      }, 1000);
    });
  }

  static async updateModule(updatedModule: MenuModuleModel): Promise<MenuModuleModel> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockWardModules.findIndex((module) => module.id === updatedModule.id);
        if (index !== -1) {
          mockWardModules[index] = updatedModule;
          resolve(updatedModule);
        } else {
          throw new Error('Module not found');
        }
      }, 1000);
    });
  }

  static async deleteModule(moduleId: number): Promise<void> {
    return new Promise((resolve) => {
      setTimeout(() => {
        const index = mockWardModules.findIndex((module) => module.id === moduleId);
        if (index !== -1) {
          mockWardModules.splice(index, 1);
          resolve();
        } else {
          throw new Error('Module not found');
        }
      }, 1000);
    });
  }
}
